/* @flow */
import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';
import DatePicker from 'react-datepicker';
import moment from 'moment';

export class DatePickerInput extends React.Component {
  render() {
    const {
      field,
      isInlineElement,
      ariaLabelledBy,
      qaTag,
      disabled,
      dateFormat,
    } = this.props;

    const inputClasses = classNames({
      'inline-element': isInlineElement,
      'has-error': this.props.field.meta.invalid,
    });

    let onChangeFunction = field.input.onChange;
    if (this.props.onChange) {
      onChangeFunction = (event) => {
        field.input.onChange(event);
        this.props.onChange(event);
      };
    }
    let handleOnBlur = ({ target: { value } }) => {
      const newRaw = new Date(value);
      if (newRaw instanceof Date && !isNaN(newRaw)) {
        onChangeFunction(newRaw);
      } 
    };
    const customDateInput = <input type="text" autoComplete="off" />
    const newRaw = new Date(field.input.value);
    var date = null;
    if (newRaw instanceof Date && !isNaN(newRaw)) {
      date = newRaw;
    }

    return (
      <div className={inputClasses}>
        <DatePicker
          id={field.input.name}
          name={field.input.name}
          dateFormat={this.props.dateFormat || "MMM d, yyyy"}
          className="form-control form-control-ie"
          selected={date}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          qaTag={qaTag}
          onChange={onChangeFunction}
          onBlur={handleOnBlur}
          disabled={disabled}
          ariaLabelledBy={ariaLabelledBy}
          width="100%"
          locale={this.props.language}
          customInput={customDateInput}
        />
      </div>
    );
  }
}

DatePickerInput.propTypes = {
  field: PropTypes.object.isRequired,
  isInlineElement: PropTypes.bool,
  ariaLabelledBy: PropTypes.string,
  qaTag: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  language: PropTypes.string,
  dateFormat: PropTypes.string,
};
